module.exports = __webpack_public_path__ + "img/four3Red.dd898161.jpg";